const types = [
  'fire',
  'water',
  'grass',
  'rock',
  'ground',
  'dark',
  'ghost',
  'psychic',
  'fighting',
  'steel',
  'fairy',
  'poison',
  'flying',
  'electric',
  'normal',
  'ice',
  'bug',
  'dragon',
]

export default types



// WEBPACK FOOTER //
// ./src/lib/types.js